import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { X, Mail, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function EmailModal({ analysisId, onClose }) {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);

  const send = async () => {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      toast.error("Enter a valid email address");
      return;
    }
    setSending(true);
    try {
      await axios.post(`${API}/analyses/${analysisId}/email`, {
        to_email: email,
        report_url: `${window.location.origin}/report/${analysisId}`,
      });
      toast.success(`Report emailed to ${email}`);
      onClose();
    } catch (e) {
      const code = e?.response?.status;
      if (code === 503) toast.error("Email isn't set up yet — a Resend API key is needed.");
      else toast.error(e?.response?.data?.detail || "Could not send the email. Please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="fl-modal-ov" data-testid="email-modal" onClick={onClose}>
      <div className="fl-modal" style={{ maxWidth: 460 }} onClick={(e) => e.stopPropagation()}>
        <div className="fl-modal-head">
          <div>
            <h3>Email this report</h3>
            <p>Sends a link to the shared report plus the full PDF, from lexgap.app.</p>
          </div>
          <button className="fl-modal-close" data-testid="email-close-btn" onClick={onClose}><X size={18} /></button>
        </div>
        <label className="fl-label">Recipient email</label>
        <input className="fl-input" data-testid="email-input" type="email" value={email}
               onChange={(e) => setEmail(e.target.value)} placeholder="colleague@chambers.co.uk"
               onKeyDown={(e) => e.key === "Enter" && send()} />
        <div className="fl-modal-cta">
          <button className="fl-btn fl-btn--primary" data-testid="email-send-btn" onClick={send} disabled={sending}>
            {sending ? <><Loader2 size={16} className="fl-spin-inline" /> Sending…</> : <><Mail size={16} /> Send report</>}
          </button>
        </div>
      </div>
    </div>
  );
}
